import * as Sentry from "@sentry/react";
import { Route } from "react-router-dom";
import { createBrowserHistory } from "history";

export const SentryRoute = Sentry.withSentryRouting(Route);
export const history = createBrowserHistory();

Sentry.init({
  dsn: "https://70fc8ecaafcfe508b11cc462649dd0f4@o4505987010985984.ingest.sentry.io/4506019435642880",
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],
  denyUrls: [String(process.env.REACT_APP_BACKEND_URL)],
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  enabled: String(process.env.REACT_APP_SENTRY_ENABLED) === "true",
});
